import { render, staticRenderFns } from "./HostingPagesSidebar.vue?vue&type=template&id=28f6cafc&scoped=true"
import script from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
export * from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./HostingPagesSidebar.vue?vue&type=style&index=0&id=28f6cafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6cafc",
  null
  
)

export default component.exports